export function isTourSeen(name: string): boolean {
  return window.localStorage.getItem(`Tour.${name}`) === "true";
}

export function setTourSeen(name: string): void {
  window.localStorage.setItem(`Tour.${name}`, "true");
}

/** Location state key: continue into the live session tour after the club dashboard tour. */
export const SESSION_TOUR_FROM_CLUB_STATE_KEY = "startSessionTour";

const PENDING_SESSION_TOUR_FROM_CLUB_KEY = "Tour.pendingSessionTour";

/** Set before submitting the new-session form from the club dashboard tour. */
export function markPendingSessionTourFromClub(): void {
  sessionStorage.setItem(PENDING_SESSION_TOUR_FROM_CLUB_KEY, "true");
}

export function consumePendingSessionTourFromClub(): boolean {
  const pending = sessionStorage.getItem(PENDING_SESSION_TOUR_FROM_CLUB_KEY) === "true";
  if (pending) sessionStorage.removeItem(PENDING_SESSION_TOUR_FROM_CLUB_KEY);
  return pending;
}
